<template>
    <div>
        <div class="border rounded-sm pt-4 pl-4 pr-4">
            <b-tabs content-class="py-5 position-relative" class="line-tabs" v-model="tabIndex" fill>
                <div class="tabs-bottom-line"></div>

                <!-- Login Details Tab -->
                <b-tab :title="$t('login_details')">
                    <login-details-tab :form-data="formData" />
                </b-tab>

                <!-- Application Information Tab -->
                <b-tab :title="$t('application_information')">
                    <application-information-tab
                        :form-data="formData"
                        :update-mode="updateMode"
                        @updated="loadData"
                    />
                </b-tab>

                <!-- Application Status Tab -->
                <b-tab :title="$t('application_status')">
                    <application-status-tab
                        :form-data="formData"
                        :update-mode="updateMode"
                        @next="tabIndex = $event"
                    />
                </b-tab>

                <!-- Reference Tab -->
                <b-tab :title="$t('reference')">
                    <reference-tab :form-id="formId" />
                </b-tab>

                <!-- Documents Tab (Swapped to Index 3) -->
                <b-tab :title="$t('documents')">
                    <documents-tab :form-id="formId" :form-data="formData" @loadData = "loadData" />
                </b-tab>

                <!-- Scholarship Tab (Swapped to Index 4) -->
                <b-tab :title="$t('scholarship')">
                    <scholarship-tab :form-id="formId" :form-data="formData"/>
                </b-tab>
            </b-tabs>
        </div>
    </div>
</template>

<script>
    // Tab Components
    import LoginDetailsTab from "../../components/admin/UpdateFormTabs/LoginDetailsTab.vue"
    import ApplicationInformationTab from "../../components/admin/UpdateFormTabs/ApplicationInformationTab.vue"
    import ApplicationStatusTab from "../../components/admin/UpdateFormTabs/ApplicationStatusTab.vue"
    import ReferenceTab from "../../components/admin/UpdateFormTabs/ReferenceTab.vue"
    import DocumentsTab from "../../components/admin/UpdateFormTabs/DocumentsTab.vue"
    import ScholarshipTab from "../../components/admin/UpdateFormTabs/ScholarshipTab.vue"

    // Service
    import BisepService from "@/services/BisepService"

    export default {
        name: 'UpdateForm',
        props: {
            updateData: {
                type: Object
            },
            formId:{
              type:Number,
              default:0
            },
            updateMode: {
                type: Boolean,
                default: false
            },
            goTab: {
                type: Number,
                default: 0
            }
        },

        components: {
            LoginDetailsTab,
            ApplicationInformationTab,
            ApplicationStatusTab,
            ReferenceTab,
            DocumentsTab,
            ScholarshipTab
        },

        data() {
            return {
                formData: {},
                tabIndex: 1
            }
        },

        created() {
            this.loadData()
            if (this.goTab !== undefined) {

                if (this.goTab === 3) this.tabIndex = 5; // Scholarship
                else if (this.goTab === 4) this.tabIndex = 4; // Documents
                else this.tabIndex = this.goTab + 1;
            }
        },

        methods: {
            async loadData() {
                try {
                    const res = await BisepService.show(this.formId)
                    this.formData = res.data.data
                } catch (err) {
                    this.showErrors(err)
                }
            }
        },

        watch: {
            goTab: {
                handler(value) {
                    if (value !== undefined) {
                         if (value === 3) this.tabIndex = 5;
                         else if (value === 4) this.tabIndex = 4;
                         else this.tabIndex = value + 1;
                    }
                }
            }
        }
    }
</script>
